module.exports = __webpack_public_path__ + "img/img_safety_phone_banner.7a68af7d.png";